import { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from './firebase_config';

const useAutoLogout = (timeout = 15 * 60 * 1000) => { // 15 min default
  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        signOut(auth);
      }, timeout);
    };

    const events = ['mousemove', 'keydown', 'scroll', 'click'];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // initiera timer direkt

    return () => {
      clearTimeout(timer);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [timeout]);
};

export default useAutoLogout;